"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var service_service_1 = require("src/app/Services/service.service");
var router_1 = require("@angular/router");
var ngx_gallery_1 = require("ngx-gallery");
var LocalModels_1 = require("src/app/api/LocalModels");
var util_1 = require("util");
var conversationService_1 = require("../../Services/conversationService");
var dialog_1 = require("@angular/material/dialog");
var environment_1 = require("src/environments/environment");
var AdvDetailComponent = /** @class */ (function () {
    function AdvDetailComponent(route, service, conversationService, matDialog, router) {
        var _this = this;
        this.route = route;
        this.service = service;
        this.conversationService = conversationService;
        this.matDialog = matDialog;
        this.router = router;
        this.isPremium = false;
        this.existedConversationId = -1;
        this.watchingByAuthor = false;
        this.perPage = 24; //count convs per page 0 is for all
        this.page = 0;
        this.galleryOptions = [
            {
                thumbnailsColumns: 4,
                width: "100%",
                height: "535px",
                imageSize: 'Contain',
                imageAnimation: ngx_gallery_1.NgxGalleryAnimation.Slide
            }
        ];
        this.galleryImages = [];
        this.canShowMap = false;
        this.isPremium = this.service.userService.isPremium();
        this.route.queryParams.subscribe(function (params) {
            var paramPage = (isNaN(params['page']) ? 1 : params['page']);
            paramPage = paramPage <= 0 ? 1 : paramPage;
            _this.page = Number(paramPage) - 1;
            var paramPerPage = (isNaN(params['perPage']) ? 24 : params['perPage']);
            if (paramPerPage)
                _this.perPage = Number(paramPerPage);
            else
                _this.perPage = 24;
        });
    }
    Object.defineProperty(AdvDetailComponent.prototype, "Location", {
        get: function () {
            if (!this.advParam.isDemo) {
                return (this.advParam.subRegionName || this.advParam.regionShortName) ? (this.advParam.subRegionName + (this.advParam.regionShortName ? (", " + this.advParam.regionShortName) : "")) : "";
            }
            else {
                var subRegionName = this.advParam.subRegionName;
                if (subRegionName && subRegionName.trim() != "") {
                    return subRegionName + (this.advParam.regionShortName ? (", " + this.advParam.regionShortName) : "");
                }
                else {
                    var currentLocation = this.service.cookieService.get("current_location_text");
                    if (currentLocation) {
                        return currentLocation.split(",")[0];
                    }
                }
                // //demo ad - calculate location based current user location
                // const currentRegionId = this.service.advService.searchDataStandard.currentSearchRule.regionId;
                // const currentSubRegionId = this.service.advService.searchDataStandard.currentSearchRule.subRegionId;
                //
                // if (currentRegionId && currentSubRegionId) {
                //   const Location = this.service.advService.getSubRegionNameById(currentRegionId, currentSubRegionId);
                //   return Location ? Location.name : '';
                // } else {
                //   let currentLocation = this.service.cookieService.get("current_location_text");
                //   if (currentLocation) {
                //     return currentLocation.split(",")[0]
                //   } else {
                //     return '';
                //   }
                // }
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvDetailComponent.prototype, "advParam", {
        get: function () {
            return this._advParam;
        },
        set: function (value) {
            this._advParam = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvDetailComponent.prototype, "dateStart", {
        get: function () {
            return this.advParam && this.advParam.dateStart ? this.advParam.dateStart.format("MM/DD/YYYY") : "";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvDetailComponent.prototype, "isImageSet", {
        get: function () {
            return this.advParam && this.advParam.images && this.advParam.images.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvDetailComponent.prototype, "isUserAdmin", {
        get: function () {
            return this.service.userService.isAdmin();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AdvDetailComponent.prototype, "advCode", {
        get: function () {
            return this.route.snapshot.paramMap.get("code");
        },
        enumerable: true,
        configurable: true
    });
    AdvDetailComponent.prototype.ngOnInit = function () {
        var _this = this;
        window.scrollTo(0, 0);
        var code = this.route.snapshot.paramMap.get("code");
        var usersearch = this.route.snapshot.paramMap.get("usersearch");
        this.advParam = this.service.advService.searchDataStandard.resultList.filter(function (v) {
            return v.advertisementId == Number(code);
        })[0];
        if (!this.advParam) {
            this.advParam = this.service.advService.searchDataUserAdv.resultList.filter(function (v) {
                return v.advertisementId == Number(code);
            })[0];
        }
        else {
            this.markCurrentAdvertisementAsSeenIfNecessary(this.advParam);
        }
        if (!this.advParam && util_1.isNumber(Number(code))) {
            this.advParam = AdvDetailComponent.initEmptyAdvMock(); //empty mock for avoid errors if null
            var conversationKey = this.route.snapshot.paramMap.get("conversationKey");
            this.service.advService.get(Number(code), conversationKey).then(function (r) {
                if (r.adveristments && r.adveristments.length > 0) {
                    _this.advParam = new LocalModels_1.DTOAdvertisementEx(r.adveristments[0]);
                    _this.afterAdvLoad();
                }
                else {
                    _this.service.route.navigate([""]).then(function () {
                        _this.service.showWarning("Adveristment not found");
                    });
                }
            });
            var dtoAdvertisementEx = this.service.advService.searchDataUserAdv.resultList.filter(function (v) {
                return v.advertisementId == Number(code);
            })[0];
            if (dtoAdvertisementEx != null) {
                this.advParam = dtoAdvertisementEx;
            }
            else {
                this.advParam = AdvDetailComponent.initEmptyAdvMock();
            }
        }
        else {
            this.afterAdvLoad();
        }
    };
    AdvDetailComponent.initEmptyAdvMock = function () {
        var mock = new LocalModels_1.DTOAdvertisementEx();
        mock.title = "";
        mock.content = "";
        mock.images = [];
        return mock;
    };
    AdvDetailComponent.prototype.markCurrentAdvertisementAsSeenIfNecessary = function (adv) {
        var _this = this;
        if (this.service.userService.isAuthenticated() && (this.service.userService.isDemo() || this.service.userService.isAdmin()) && adv.isDemo == false && (adv.seen == false || adv.seenAdmin == false)) {
            this.service.advService.markAdvertisementAsSeen(adv.advertisementId, this.isUserAdmin).then(function (res) {
                _this.advParam.seen = true;
                var index = _this.service.advService.searchDataStandard.resultList.findIndex(function (i) { return i.advertisementId == adv.advertisementId; });
                if (index > -1) {
                    if (_this.service.userService.isDemo()) {
                        _this.service.advService.searchDataStandard.resultList[index].seen = true;
                    }
                    if (_this.service.userService.isAdmin()) {
                        _this.service.advService.searchDataStandard.resultList[index].seenAdmin = true;
                    }
                }
            }).catch(function (err) {
                return _this.service.showError(err);
            });
        }
    };
    AdvDetailComponent.prototype.afterAdvLoad = function () {
        var _this = this;
        if (this.advParam) {
            var currentUserId = this.service.userService.getUserId();
            if (this.advParam.userId == currentUserId) {
                this.watchingByAuthor = true;
            }
            this.conversationService.getActiveConversationId(this.advParam.advertisementId).toPromise().then(function (id) {
                _this.existedConversationId = id;
            });
            this.markCurrentAdvertisementAsSeenIfNecessary(this.advParam);
            this.advParam.images = this.advParam.images || [];
            this.advParam.images.sort(function (a, b) {
                return a.orderIndex > b.orderIndex ? 1 : a.orderIndex < b.orderIndex ? -1 : 0;
            });
            this.advParam.images.forEach(function (v) {
                _this.galleryImages.push({
                    small: environment_1.environment.apiBaseUrl + "/FileGet/" + v.fileName + "/139x125",
                    medium: environment_1.environment.apiBaseUrl + "/FileGet/" + v.fileName + "/800x600",
                    big: environment_1.environment.apiBaseUrl + "/FileGet/" + v.fileName
                });
            });
            if (this.advParam.location && this.advParam.location != "") {
                var location_1 = this.advParam.location.split("/").map(function (str) { return parseFloat(str); });
                if (location_1.length == 2) {
                    this.canShowMap = true;
                    this.lat = location_1[0];
                    this.lng = location_1[1];
                }
            }
            if (!this.canShowMap) {
                this.service.advService
                    .getLocationDataByZipCode(this.advParam.zipCode)
                    .toPromise()
                    .then(function (v) {
                    try {
                        if (v.results[0].geometry.location.lat) {
                            _this.canShowMap = true;
                            _this.lat = v.results[0].geometry.location.lat;
                            _this.lng = v.results[0].geometry.location.lng;
                        }
                    }
                    catch (e) {
                        console.log(e);
                    }
                });
            }
        }
    };
    //TODO dac chyba messagecomponent typ jako send-conversation-message lub textinput-bar
    AdvDetailComponent.prototype.sendInitialConversationMessage = function (messageComponent) {
        var _this = this;
        if (!this.service.userService.isAuthenticated()) {
            this.service.showLogin();
        }
        else {
            var messageParams = messageComponent.prepareMessageParams();
            messageComponent.submitStart();
            this.conversationService.sendStartingConversationMessage(this.service.userService.getUserId(), this.advParam.userId, messageParams.nick, messageParams.content, this.advParam.advertisementId, messageParams.images, this.advParam.isDemo ? this.advParam.subRegionName : null, this.advParam.isDemo ? this.advParam.regionShortName : null, this.advParam.isDemo ? this.advParam.dateStart : null).then(function (result) {
                messageComponent.submitFinished();
                var thanksInfo = _this.service.showInformation("Your message has been sent");
                setTimeout(function () {
                    thanksInfo.dismiss();
                    _this.router.navigate(['/conversations']);
                }, 2000);
                messageComponent.clear();
            }).catch(function (res) {
                messageComponent.submitFinished();
                _this.service.showError(res);
            });
        }
    };
    AdvDetailComponent.prototype.resolveAdvTitle = function (advParam) {
        if (!advParam) {
            return "";
        }
        else
            return advParam.title || '';
    };
    AdvDetailComponent.prototype.ageIsValid = function () {
        return this.advParam && this.advParam.age && this.advParam.age.trim() != '';
    };
    return AdvDetailComponent;
}());
exports.AdvDetailComponent = AdvDetailComponent;
